import React from "react";
import CategoryPage from "./CategoryPage";

function National({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="National"
      parentCategory="News"
      posts={posts}
      publications={publications}
    />
  );

}

export default National;